module.exports = __webpack_public_path__ + "static/media/speech_icon.78d4a476.svg";